import { useDispatch } from "react-redux";
import { getPurchaseItemsList } from "../connections/getApi";
import { setError, setLoading } from "../redux/slices/pharmacySlice";
import { useQuery } from "@tanstack/react-query";

const UseFetchPurchaseItems = (page, pageSize, q, startDate, endDate) => {
  const dispatch = useDispatch();
  return useQuery({
    queryKey: ["getPurchaseItemsList", page, pageSize, q, startDate, endDate],
    queryFn: () => getPurchaseItemsList(page, pageSize, q, startDate, endDate),
    onError: () => {
      dispatch(setError(true));
      dispatch(setLoading(false));
    },
    onSettled: () => {
      dispatch(setLoading(false));
    },
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: true,
   
  });
};

export default UseFetchPurchaseItems;
